function ratiologos(options) {
    let images = document.querySelectorAll(`${options.element}`);

    images.forEach(function(el) {
        el.style.display = "none";
        el.style.maxWidth = "60%";
    });
    

    function adjustImageWidth(image) {
        if (options.base) {
            var widthBase = `${options.base}`;
        } else {
            var widthBase = 100;
        }
        if (options.scale) {
            var scaleFactor = `${options.scale}`;
        } else {
            var scaleFactor = 0.525;
        }
        var imageRatio = image.naturalWidth / image.naturalHeight;

        image.width = Math.pow(imageRatio, scaleFactor) * widthBase;
        image.style.display = "block";
    }

    window.onload = function () {
        images.forEach(function (image) {
            adjustImageWidth(image);
        });
    }

}

module.exports.ratiologos = ratiologos;